// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7959) return "static/chunks/7959.6a910717611c8df2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1214":"a9cd44dedfed6483","1307":"75d23ae840c1f88f","5422":"cb4864697ec2ae90"}[chunkId] + ".js";
};